module.exports = __webpack_public_path__ + "static/img/ls12.c40a288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/ls12.png
// module id = n//K
// module chunks = 12